import React from "react";
import { Accordion } from "react-bootstrap";
import { ListGroup } from "react-bootstrap";
// import AccordianComp from "./AccordianComp";
import "../../styles/forum.css";


function Questions() {
  return (
    <>
      <h1 className="header">Past Discussions</h1>
      <Accordion className="acc" defaultActiveKey="0">
        <Accordion.Item className="accordian" eventKey="0">
          <Accordion.Header>Discussion Q1) : How to add aa package into react??</Accordion.Header>
          <Accordion.Body>
            <ListGroup as="ol" numbered>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">Meith Nav : </div>
                  Try installing the module first and then re-running the
                  compiler.
                </div>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">rraheja41 : </div>
                  Faced the same issue try doing it using bash over powershell.
                </div>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">Dhishil</div>
                  Do anyone want to collaborate on a similar project?? Please
                  contact me through the app's chat.
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item className="accordian" eventKey="4">
          <Accordion.Header>Discussion Q) 223: What is the process for ope scource collaboration ?? </Accordion.Header>
          <Accordion.Body>
            <ListGroup as="ol" numbered>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">User444</div>
                  it's not really possible to answer this without seeing your
                  project, or at least having more information on how your
                  project is organized. Are you sure that moment is installed in
                  your node modules? What is your gruntfile doing? Where are you
                  adding this script tag? If you have a public GitHub repo I'm
                  happy to take a look
                </div>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">Coder40</div>
                  @user841760 did you get a solution to this? I am working on a
                  ReactJS project and facing the same issue. TIA
                </div>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">User3</div>
                  app.use('/node_modules', express.static(__dirname +
                  '/node_modules/moment/moment.js'));
                  <br/>
                  Edit: Or if you just want to make it work, try to load moment.js from CDN.

                </div>
              </ListGroup.Item>
            </ListGroup>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item className="accordian" eventKey="1">
          <Accordion.Header>Discussion #Resolve my doubts!!! Need a collaborator for a project....</Accordion.Header>
          <Accordion.Body>
            <ListGroup as="ol" numbered>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">User1</div>
                  Cras justo odio
                </div>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">User2</div>
                  Cras justo odio
                </div>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">User3</div>
                  Cras justo odio
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item className="accordian" eventKey="2">
          <Accordion.Header>Discussion #1</Accordion.Header>
          <Accordion.Body>
            <ListGroup as="ol" numbered>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">User1</div>
                  Cras justo odio
                </div>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">User2</div>
                  Cras justo odio
                </div>
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">User3</div>
                  Cras justo odio
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default Questions;
